<div class="d-flex align-items-center">
  <fa-icon class="me-4"
           [icon]="['fab', 'apple']"></fa-icon>
  <div class="flex-grow-1 lh-1 text-truncate">
    <h6 class="mb-1">{{ osupdate()?.humanReadableName }}</h6>
    <p class="mb-0 lh-1 text-truncate">
      <small class="text-truncate">Product key: {{ osupdate()?.productKey }}</small>
      <br />
      <small class="text-truncate">Version: {{ osupdate()?.version }}</small>
    </p>
  </div>
  <button class="btn btn-danger"
          [hidden]="!(isEditing() && allowEditing())"
          (click)="delete()">
    <fa-icon [icon]="['far', 'trash-alt']"></fa-icon>
  </button>
</div>